import LoyaltyView from "./containers/LoyaltyView";
import { JoinStatusProvider } from "./context/join-status";
import { LocaleProvider } from "./context/locale-provider";
import { joinLoyaltyReducer } from "./state/join-loyalty/reducer";
import MembersDay from "./containers/MembersDay";
import PropTypes from "prop-types";
import styles from "./styles";

export default function App({ appConfig, assetsUrl, page, storeData }) {
  return (
    <>
      <LocaleProvider
        languageStrings={storeData?.languageStrings}
        localisedLinks={storeData?.localisedLinks}
      >
        {page === "loyalty-faq" && (
          <JoinStatusProvider
            initialState={{
              loading: true,
              showSuccess: false,
              errorCode: "",
              loyaltyData: {},
              isLoggedIn: false,
              loyaltyAvailableToCustomer: false,
              currentTierId: "",
            }}
            reducer={joinLoyaltyReducer}
          >
            <div className={styles.container}>
              <LoyaltyView appConfig={appConfig} assetsUrl={assetsUrl} />
            </div>
          </JoinStatusProvider>
        )}
        {page === "members-day" && <MembersDay appConfig={appConfig} />}
      </LocaleProvider>
    </>
  );
}

App.propTypes = {
  appConfig: PropTypes.object,
  assetsUrl: PropTypes.string,
  page: PropTypes.string,
  storeData: PropTypes.object,
};
